import { FolderSimplePlus } from "@phosphor-icons/react";
import { WordIcon, PdfIcon, ExcelIcon, TextIcon, ImageIcon, EpubIcon, GenericFileIcon } from "../components/icons/FileTypeIcons";

export const getFileIcon = (fileName, type, _active) => {
  if (type === "folder") {
    return <FolderSimplePlus size={16} />;
  }

  const ext = fileName?.split(".").pop()?.toLowerCase();
  switch (ext) {
    case "pdf":
      return <PdfIcon size={16} />;
    case "docx":
    case "doc":
      return <WordIcon size={16} />;
    case "xlsx":
    case "xls":
      return <ExcelIcon size={16} />;
    case "txt":
      return <TextIcon size={16} />;
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "svg":
    case "webp":
    case "bmp":
    case "tiff":
      return <ImageIcon size={16} />;
    case "epub":
      return <EpubIcon size={16} />;
    default:
      return <GenericFileIcon size={16} />;
  }
};

export const getFileIconBySize = (fileName, type, size = 16) => {
  if (type === "folder") {
    return <FolderSimplePlus size={size} />;
  }

  const ext = fileName?.split(".").pop()?.toLowerCase();
  switch (ext) {
    case "pdf":
    case "application/pdf":
      return <PdfIcon size={size} />;
    case "docx":
    case "doc":
      return <WordIcon size={size} />;
    case "xlsx":
    case "xls":
      return <ExcelIcon size={size} />;
    case "txt":
      return <TextIcon size={size} />;
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "svg":
    case "webp":
    case "bmp":
    case "tiff":
      return <ImageIcon size={size} />;
    case "epub":
      return <EpubIcon size={size} />;
    default:
      return <GenericFileIcon size={size} />;
  }
};

export const isEpubFile = (fileName) =>
  (fileName?.split(".").pop() || "").toLowerCase() === "epub";

export const formatFileSize = (size, type) => {
  if (type === "folder" || size === "(empty folder)") return "(empty folder)";
  if (size == null) return "";
  if (size === 0) return "0 Bytes";
  if (typeof size !== 'number' || !Number.isFinite(size)) return "";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(size) / Math.log(k));

  return Number.parseFloat((size / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
